<template>
  <div class="">
    <div class="columns is-gapless is-border-top has-bg-white is-border-left is-border-right">
      <div class="has-bg-white is-padding-left is-padding-right is-padding-top-small is-padding-bottom-small">
        <span class="is-uppercase title is-6">Financement</span>
      </div>
      <!-- <div v-if="reminder" class="column is-self-centered is-padding-left is-padding-right has-text-right">
        <div class="has-text-danger is-size-6">Rappel : Le <b> {{reminder.date | dateReminder}} </b> - Création : <b v-if="'custom_fields' in reminder && 'auto' in reminder.custom_fields && reminder.custom_fields.auto">Automatique</b><b v-else>Manuel</b> -
          Destinataire : <b>{{reminder.user_name}}</b>
          <a class="has-text-danger is-underline is-italic" @click.prevent.stop="openReminder">(Modifier)</a>
        </div>
      </div> -->
      <!-- <div class="column is-narrow has-bg-danger is-flex is-padding-small">
        <span class="icon has-text-white is-self-centered"><i class="fas fa-alarm-clock"></i></span>
      </div> -->
    </div>
    <div v-if="!financementCheck" class="notification is-warning has-text-centered is-marginless"><p
            class="is-uppercase is-size-7 has-text-weight-medium">
      VOUS DEVEZ VÉRFIER ET/ou COMPLÉTER LES INFORMATIONS MANQUANTES.<br>lES INFORMATIONS MAQUANTES SONT PRÉCÉDÉES DE
      CETTE ICONE <span class="icon has-text-danger is-size-5"><i class="fas fa-check-circle"></i></span> DANS les
      rubriques suivantes
    </p></div>
    <div class="columns is-12 is-gapless is-padding-left-small is-padding-right-small is-vcentered is-min-height-50"
         :class="adv.financement.use_loan ? 'is-border-top has-bg-light is-border-left is-border-right is-border-bottom ' : 'has-bg-dark'">
      <div class="column is-narrow">
        <div class="is-padding-top-xsmall is-padding-bottom-xsmall">
          <div>
            <input id="use_loan" v-model="useLoan" @input="commitAdv()" name="use_loan"
                   class="switch is-success is-rounded" type="checkbox">
            <label for="use_loan" style="font-size: 12.5px" :class="adv.financement.use_loan ? '' : 'has-text-white'"
                   class="is-uppercase">Le réservataire déclare ne pas recourir à un ou plusieurs prêt bancaire</label>
          </div>
        </div>
      </div>
    </div>
    <div v-if="adv.financement.use_loan">
      <template v-for="(loan, idx) in loans">
        <loan-item :source="loan" :multiple-loan="multipleLoan" :index="idx" @upload="updateDocument" :key="idx"
                   @removeLoan="removeLoan" @commitAdv='commitAdv'></loan-item>
      </template>
      <div class="row-width-actions-bar">
        <button @click="addLoan" class="page-header-btn button is-grey-dark is-fullwidth is-radiusless"><span>Ajouter une liste de prêt</span>
        </button>
      </div>
    </div>
    <div class="has-bg-white is-border is-margin-top-xxsmall">
      <div class="row-width-actions-bar columns is-gapless">
        <div class="column is-self-centered is-padding-left is-padding-top-xsmall is-padding-bottom-xsmall">
          <span class="is-uppercase title is-6">Commentaire</span>
        </div>
        <div class="column is-narrow is-border-left">
          <button class="page-header-btn is-small is-square" @click="openComment = !openComment"><span
                  class="icon is-size-4">
            <i v-if="!openComment" class="fal fa-chevron-down"></i>
            <i v-else class="fal fa-chevron-up"></i>
            </span></button>
        </div>
      </div>
      <template v-if="openComment">
        <div v-if="!openWysi" class="vadDiscussion is-border-top">
          <div
                  class="vadDiscussion--bulle is-size-6 is-min-height-50 vadDiscussion--bulle--has-actions is-cut is-padding-left">
            <div class="content" v-if="(isAdmin || isSectorManager) && adv.financement.comment" v-html="adv.financement.comment"></div>
            <div class="content" v-else-if="!(isAdmin || isSectorManager) && adv.financement.seller_comment"
                 v-html="adv.financement.seller_comment"></div>
            <div class="content" v-else>Aucun commentaire</div>
            <div class="actionsOnRow actionsOnRow--vertical">
              <div class="">
                <button @click="openWysiwyg" class="is-min-height-full">
                  <span class="icon is-small"><i class="fal fa-edit"></i></span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="is-border-top columns is-gapless">
          <div class="column" v-if="isAdmin || isSectorManager">
            <wysiwyg-editor
                    :light='true' :tooltip-top="true"
                    :model="commentaire"
                    @change="val => commentaire = val"
                    class="editr--bottom-toolbar no-toolbar editr--height-small content is-borderless">
            </wysiwyg-editor>
          </div>
          <div class="column" v-else>
            <wysiwyg-editor
                    :light='true' :tooltip-top="true"
                    :model="seller_commentaire"
                    @change="val => seller_commentaire = val"
                    class="editr--bottom-toolbar no-toolbar editr--height-small content is-borderless">
            </wysiwyg-editor>
          </div>
          <div class="actionsOnRow actionsOnRow--vertical">
            <div>
              <button @click="saveAdv()" type="button" class="button is-success">
                <span class="icon is-small"><i class="fal fa-save"></i></span>
              </button>
            </div>
            <div class="">
              <button type="button" class="actionsOnRow-btn--hoverIsDanger" @click="openWysi = false">
                <span class="icon is-small"><i class="fal fa-times"></i></span>
              </button>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import { AdvMx, DefaultValues } from '@/mixins'
  import { mapGetters } from 'vuex'
  import LoanItem from './LoanItem'

  export default {
    name: 'Financement',
    mixins: [AdvMx, DefaultValues],
    components: { LoanItem },
    data () {
      return {
        reminder: {},
        loans: [],
        openComment: true,
        openWysi: false,
        commentaire: null,
        seller_commentaire: null
      }
    },
    computed: {
      useLoan: {
        get: function () {
          return !this.adv.financement.use_loan
        },
        set: function (newValue) {
          this.adv.financement.use_loan = !newValue
        }
      },
      multipleLoan () {
        return this.loans.length > 1
      },
      ...mapGetters(['currentUserProfil']),
      currentComment () {
        return this.adv.financement.comment
      },
      loanTotalAmount () {
        return this.loans.reduce((accum, loan) => {
          let amount
          if (!loan.amount || isNaN(loan.amount)) {
            amount = 0
          } else {
            amount = Number(loan.amount)
          }
          return accum + amount
        }, 0)
      },
      apportTotalAmount () {
        return this.loans.reduce((accum, loan) => {
          let apport
          if (!loan.apport || isNaN(loan.apport)) {
            apport = 0
          } else {
            apport = Number(loan.apport)
          }
          return accum + apport
        }, 0)
      },
      canEditPrice () {
        return !this.sourceShares.slice().reduce((a, b) => {
          if (b.deposits.length) {
            b.deposits.forEach((x) => {
              if (x.terminated) a++
            })
          }
          if (b.terminated) a++
          return a
        }, 0)
      },
      financementCheck () {
        if (!this.financement.use_loan) {
          return true
        } else {
          let loansTrue = []
          this.loans.forEach(loan => {
            if (loan.bank_name !== null && loan.bank_name !== '' &&
              loan.depot_de_dossier !== null && loan.depot_de_dossier !== '' &&
              loan.edition_de_l_offre !== null && loan.edition_de_l_offre !== '' &&
              loan.loan_apport !== null && loan.loan_apport !== '' &&
              loan.loan_type !== null && loan.loan_type !== '' &&
              loan.loan_value !== null && loan.loan_value !== '' &&
              loan.signature_de_l_offre !== null && loan.signature_de_l_offre !== '') loansTrue.push(loan)
          })
          if (loansTrue.length === this.loans.length) {
            return true
          } else {
            return false
          }
        }
      }
    },
    methods: {
      // loadReminders () {
      //   this.isLoadingReminders = true
      //   let params = {
      //     custom_fields__code: 'financialInfoRequiredAutoReminder',
      //     custom_fields__adv: this.advPk,
      //     user: this.currentUserPk
      //   }
      //   this.$api.reminderService.get(params).then(r => {
      //     console.log(r.data.items)
      //     if (r.data.items) {
      //       this.reminder = r.data.items[0]
      //     }
      //   })
      // },
      openWysiwyg () {
        this.openWysi = true
        this.$nextTick(() => {
          let wysiElem
          if (!this.adv.financement.comment && !this.adv.financement.seller_comment) {
            wysiElem = document.getElementsByClassName('ql-editor ql-blank')
            wysiElem = wysiElem[0]
            wysiElem.setAttribute('contenteditable', 'true')
            wysiElem.focus()
          } else {
            let selection = document.getSelection()
            let range = document.createRange()
            let contenteditable = document.querySelector('div[contenteditable="true"]')

            if (contenteditable.lastChild.nodeType === 3) {
              range.setStart(contenteditable.lastChild, contenteditable.lastChild.length)
            } else {
              range.setStart(contenteditable, contenteditable.childNodes.length)
            }
            selection.removeAllRanges()
            selection.addRange(range)
          }
        })
      },
      saveAdv () {
        let adv = Object.assign({}, this.adv)
        this.$set(adv.financement, 'comment', this.commentaire)
        this.$set(adv.financement, 'seller_comment', this.seller_commentaire)
        this.$emit('saveAdv', adv)
        this.openWysi = false
      },
      // openReminder () {
      //   let params = {
      //     defaultTitle: this.reminder.title,
      //     date: moment(this.reminder.date).format('DD/MM/YYYY HH:mm'),
      //     source: {
      //       user: this.reminder.user
      //     }
      //   }
      //   this.$store.commit('setQuickview', {mode: 'NEW_REMINDER', params})
      // },
      changeDeposit () {
        this.adv.financement.secury_deposit = !this.adv.financement.secury_deposit
      },
      addLoan () {
        this.loans.push({
          accord_banque: null,
          depot_de_dossier: null,
          bank_name: null,
          edition_de_l_offre: null,
          signature_de_l_offre: null,
          loan_value: null,
          loan_type: null,
          loan_apport: null,
          has_mandat_courtage: false,
          document: {
            cloudinary_id: null,
            cloudinary_version: null,
            display: null,
            filename: null,
            fus_id: null,
            path: null,
            s3_key: null,
            s3_path: null
          }
        })
        this.commitAdv()
      },
      addEmptyLoan () {
        this.loans.push({
          accord_banque: null,
          depot_de_dossier: null,
          bank_name: null,
          edition_de_l_offre: null,
          signature_de_l_offre: null,
          loan_value: null,
          loan_type: null,
          loan_apport: null,
          has_mandat_courtage: false,
          document: {
            cloudinary_id: null,
            cloudinary_version: null,
            display: null,
            filename: null,
            fus_id: null,
            path: null,
            s3_key: null,
            s3_path: null
          }
        })
      },
      removeLoan (index) {
        this.loans.splice(index, 1)
        this.commitAdv()
      },
      commitAdv () {
        let save = false
        let adv = Object.assign({}, this.adv)
        console.log(this.loans)
        this.$set(adv.financement, 'loans', this.loans)
        for (let item of adv.financement.loans) {
          if (item.depot_de_dossier) {
            item.depot_de_dossier = (new Date(item.depot_de_dossier)).toUTCString()
          }
          if (item.accord_banque) {
            item.accord_banque = (new Date(item.accord_banque)).toUTCString()
          }
          if (item.edition_de_l_offre) {
            item.edition_de_l_offre = (new Date(item.edition_de_l_offre)).toUTCString()
          }
          if (item.signature_de_l_offre) {
            item.signature_de_l_offre = (new Date(item.signature_de_l_offre)).toUTCString()
          }
        }
        this.$emit('commit', adv, save)
      }
    },
    created () {
      // this.loadReminders()
      if (this.adv.financement.comment) this.commentaire = this.adv.financement.comment
      if (this.adv.financement.seller_comment) this.seller_commentaire = this.adv.financement.seller_comment
      if (this.adv.financement.loans && this.adv.financement.loans.length) {
        for (let item of this.adv.financement.loans) {
          if (item.depot_de_dossier) {
            item.depot_de_dossier = (new Date(item.depot_de_dossier)).toUTCString()
          }
          if (item.accord_banque) {
            item.accord_banque = (new Date(item.accord_banque)).toUTCString()
          }
          if (item.edition_de_l_offre) {
            item.edition_de_l_offre = (new Date(item.edition_de_l_offre)).toUTCString()
          }
          if (item.signature_de_l_offre) {
            item.signature_de_l_offre = (new Date(item.signature_de_l_offre)).toUTCString()
          }
        }
        this.loans = this.adv.financement.loans.slice()
      } else {
        this.addEmptyLoan()
      }
    }
  }
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/adv/FeuilleDeRoute/Financement.vue